import gql from "graphql-tag";

export const DOCUMENT_TYPES = gql`
  query documentType {
    documentTypes {
      id
      name
    }
  }
`;
